import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Router } from '@angular/router';
import { UsuarioResponse } from '../../../shared/services/responses/usuario/usuario.response';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { Masks, MaskService } from '../../../shared/services/mask.service';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { UsuarioLoginResponse } from '../../../shared/services/responses/usuario/usuario-login.response';
import { Funcionalidade } from '../../../shared/services/models/usuario/funcionalidade.model';
import { EmpresaService } from '../../../shared/services/apis/usuario/empresa.service';
import { EmpresaResponse } from '../../../shared/services/responses/usuario/empresa.response';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TimezoneStruct } from '../../../shared/services/structs/usuario/timezone.struct';
import { firstValueFrom, map, Observable } from 'rxjs';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';
import { cnpjValidator } from '../../../shared/validators/cnpj.validator';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import {
  PageScrollSpyComponent,
  ScrollSpySection,
} from '../../../shared/components/page-scroll-spy/page-scroll-spy.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FooterActionComponent } from '../../../shared/components/footer-action/footer-action.component';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import {
  PesquisaCodigoTributacaoModalComponent,
  PesquisaCodigoTributacaoModalData,
  PesquisaCodigoTributacaoModalResult,
} from '../../../shared/components/pesquisa-codigo-tributacao-modal/pesquisa-codigo-tributacao-modal.component';
import { EmptyStateComponent } from '../../../shared/components/empty-state/empty-state.component';
import {
  EmpresaLogoDialogComponent,
  EmpresaLogoDialogData,
  EmpresaLogoDialogResult,
} from '../../../shared/components/empresa-logo-dialog/empresa-logo-dialog.component';
import { EmpresaLogoEdicaoStruct } from '../../../shared/services/structs/usuario/empresa-logo-edicao.struct';
import { TipoLogoEmpresa } from '../../../shared/enums/usuario/tipo-logo-empresa.enum';
import { EmpresaLogoRequest } from '../../../shared/services/requests/usuario/empresa-logo.request';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { EmpresaStruct } from '../../../shared/services/structs/usuario/empresa.struct';
import { EmpresaInscricaoSubstitutoTributarioStruct } from '../../../shared/services/structs/usuario/empresa-inscricao-substituto-tributario.struct';
import { EmpresaDadosFiscaisRequest } from '../../../shared/services/requests/usuario/empresa-dados-fiscais.request';
import { MotorFiscalLookupService } from '../../../shared/services/apis/motor-fiscal/motor-fiscal-lookup.service';
import { LookupItemStruct } from '../../../shared/services/structs/motor-fiscal/lookup-item.struct';
import { RegimeTributarioEnum } from '../../../shared/enums/motor-fiscal/regime-tributario.enum';
import { SituacaoContribuinteEmpresaEnum } from '../../../shared/enums/motor-fiscal/situacao-contribuinte-empresa.enum';
import { AlertCardComponent } from '../../../shared/components/alert-card/alert-card.component';
import {
  UfOption,
  UnidadeFederativaService,
} from '../../../shared/services/apis/usuario/unidade-federativa.service';

@Component({
  selector: 'app-empresa-cadastro',
  imports: [
    HeaderComponent,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSelectModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatAutocompleteModule,
    NgxMaskDirective,
    PageScrollSpyComponent,
    MatDialogModule,
    FooterActionComponent,
    SelectPesquisavelComponent,
    EmptyStateComponent,
    AlertCardComponent,
  ],
  providers: [provideNgxMask()],
  templateUrl: './empresa-cadastro.component.html',
  styleUrl: './empresa-cadastro.component.css',
})
export class EmpresaCadastroComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;
  public timezoneFiltrado: Observable<TimezoneStruct[]>;
  public sections: ScrollSpySection[] = [
    { id: 'info-basica', label: 'Informações Básicas' },
    { id: 'dados-fiscais', label: 'Dados Fiscais' },
    { id: 'endereco', label: 'Endereço' },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private empresaService: EmpresaService,
    private alertService: AlertService,
    private router: Router,
    private maskService: MaskService,
    private authService: AuthService,
    private dialog: MatDialog,
    private motorFiscalLookupService: MotorFiscalLookupService,
    private unidadeFederativaService: UnidadeFederativaService
  ) {
    this.moduloEnum = ModuloEnum.Configuracoes;
    this.funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Empresa;
  }

  public model: FormGroup;
  public _empresaResponse: EmpresaResponse;
  public _usuarioResponse: UsuarioResponse;
  public masks: Masks;
  public userLoginResponse: UsuarioLoginResponse;

  public readonly dataMaxima: Date = new Date();

  public listaRegimeTributario: LookupItemStruct[] = [];
  public listaRegimeApuracaoIrpj: LookupItemStruct[] = [];
  public listaSituacaoContribuinteEmpresa: LookupItemStruct[] = [];

  /** Linha de ajuda de cada situação, em linguagem para quem não é da área fiscal. */
  private readonly textoAjudaSituacaoContribuinteEmpresa: Record<SituacaoContribuinteEmpresaEnum, string> = {
    [SituacaoContribuinteEmpresaEnum.ContribuinteIcms]:
      'A empresa apura ICMS e tem Inscrição Estadual ativa no estado.',
    [SituacaoContribuinteEmpresaEnum.NaoContribuinteIcms]:
      'A empresa não apura ICMS e não tem Inscrição Estadual.',
    [SituacaoContribuinteEmpresaEnum.ContribuinteExclusivoIbsCbs]:
      'A empresa paga os novos tributos da Reforma Tributária (IBS e CBS), mas não apura ICMS.',
  };

  /** Consequências do enquadramento exclusivo de IBS/CBS exibidas no card da situação. */
  public readonly frasesEnquadramentoContribuinteExclusivoIbsCbs: string[] = [
    'As notas fiscais da empresa passam a ser enviadas pela SEFAZ Virtual do Rio Grande do Sul (SVRS).',
    'Revise as naturezas de operação: as notas desta empresa não destacam ICMS.',
    'Enquanto as regras atuais estiverem em vigor, a empresa não pode emitir NFC-e (nota fiscal de consumidor).',
    'Enquanto as regras atuais estiverem em vigor, não é possível informar inscrição estadual de substituto tributário.',
  ];
  public listaUnidadeFederativa: UfOption[] = [];

  // Estado local da logo - persistido junto com os demais campos pelo footer-action.
  public logoUrlPreview: string | null = null;
  public logoEdicao: EmpresaLogoEdicaoStruct | null = null;
  public isLoadingSalvar: boolean = false;
  private logoUrlOriginal: string | null = null;
  private logoBlobUrlAtivo: string | null = null;
  private logoFileSelecionado: File | null = null;

  async ngOnInit(): Promise<void> {
    this.masks = this.maskService.getMasks();

    // Nome Empresa, CNPJ, Fuso horario e o bloco de Endereco seguem somente leitura: a edicao
    // desses campos vive em outras telas. Os campos habilitados abaixo sao os desta US.
    this.model = this.formBuilder.group({
      nomeEmpresa: new FormControl({ value: '', disabled: true }, [Validators.required, requiredTrim]),
      cnpj: new FormControl({ value: '', disabled: true }, [Validators.required, cnpjValidator()]),
      listaTimezone: new FormControl({ value: '', disabled: true }, Validators.required),

      nomeFantasia: new FormControl<string | null>(null, [Validators.maxLength(100)]),
      dataFundacao: new FormControl<Date | null>(null),

      cnaePrincipal: new FormControl<string | null>(null),
      idRegimeTributario: new FormControl<number | null>(null),
      idRegimeApuracaoIrpj: new FormControl<number | null>(null),
      inscricaoEstadual: new FormControl<string | null>(null),
      idSituacaoContribuinteEmpresa: new FormControl<number>(SituacaoContribuinteEmpresaEnum.ContribuinteIcms, {
        nonNullable: true,
      }),
      inscricaoMunicipal: new FormControl<string | null>(null),
      inscricaoSuframa: new FormControl<string | null>(null),
      listaSubstitutoTributario: this.formBuilder.array([]),

      cep: new FormControl({ value: '', disabled: true }),
      logradouro: new FormControl({ value: '', disabled: true }),
      numero: new FormControl({ value: '', disabled: true }),
      complemento: new FormControl({ value: '', disabled: true }),
      bairro: new FormControl({ value: '', disabled: true }),
      municipio: new FormControl({ value: '', disabled: true }),
      unidadeFederativa: new FormControl({ value: '', disabled: true }),
    });

    // A regra de UF unica e de par UF/IE completo vale a cada digitacao, nao so no submit.
    this.listaSubstitutoTributario.valueChanges.subscribe(() =>
      this.validarSubstitutosTributarios()
    );

    // Trocar o regime tributario invalida a apuracao escolhida para o regime anterior.
    this.idRegimeTributario.valueChanges.subscribe(() => {
      this.idRegimeApuracaoIrpj.setValue(null, { emitEvent: false });
      this.sincronizarRegimeApuracaoIrpj(true);
    });

    this.idSituacaoContribuinteEmpresa.valueChanges.subscribe(() => this.onSituacaoContribuinteEmpresaChange());

    this.validarPermissoes();
    this.carregarLookups();
    await this.popularDadosEmpresa();
  }

  // ── Getters de conveniência ───────────────────────────────────────────────

  public get listaSubstitutoTributario(): FormArray {
    return this.model.get('listaSubstitutoTributario') as FormArray;
  }

  public get cnaePrincipal(): FormControl {
    return this.model.get('cnaePrincipal') as FormControl;
  }

  public get idRegimeTributario(): FormControl {
    return this.model.get('idRegimeTributario') as FormControl;
  }

  public get idRegimeApuracaoIrpj(): FormControl {
    return this.model.get('idRegimeApuracaoIrpj') as FormControl;
  }

  /**
   * `true` regime com apuração, `false` outro regime, `null` NÃO SEI — e o `null` é o que importa: o
   * lookup falha devolvendo lista vazia (`of([])`), e tratar isso como `false` faria o envio
   * apagar a apuração gravada num Salvar que nem tocou nesses campos.
   */
  private get classificacaoRegime(): boolean | null {
    const idRegime = this.idRegimeTributario.value;
    if (idRegime == null) return false;

    const codigo = this.listaRegimeTributario.find(x => x.id === idRegime)?.codigo;
    if (codigo === undefined) return null;

    return codigo === RegimeTributarioEnum.RegimeNormal.toString()
      || codigo === RegimeTributarioEnum.SimplesNacionalExcessoSublimite.toString();
  }

  public get usaRegimeApuracao(): boolean {
    return this.classificacaoRegime === true;
  }

  public get idSituacaoContribuinteEmpresa(): FormControl<number> {
    return this.model.get('idSituacaoContribuinteEmpresa') as FormControl<number>;
  }

  /** A Inscrição Estadual só existe para quem apura ICMS. */
  public get isContribuinteIcms(): boolean {
    return this.idSituacaoContribuinteEmpresa.value === SituacaoContribuinteEmpresaEnum.ContribuinteIcms;
  }

  public get isContribuinteExclusivoIbsCbs(): boolean {
    return this.idSituacaoContribuinteEmpresa.value === SituacaoContribuinteEmpresaEnum.ContribuinteExclusivoIbsCbs;
  }

  public get ajudaSituacaoContribuinteEmpresa(): string {
    return this.textoAjudaSituacaoContribuinteEmpresa[this.idSituacaoContribuinteEmpresa.value as SituacaoContribuinteEmpresaEnum] ?? '';
  }

  public get ajudaInscricaoEstadual(): string {
    return this.isContribuinteIcms
      ? 'Necessária para emissão de nota fiscal de produto'
      : 'A ausência da Inscrição Estadual é o que caracteriza este enquadramento perante a SEFAZ.';
  }

  public get isSalvarDesabilitado(): boolean {
    if (this.isLoadingSalvar) return true;
    const temAlteracaoPendente = this.model.dirty || this.logoEdicao !== null;
    return !temAlteracaoPendente || this.model.invalid;
  }

  validarPermissoes(): void {
    this.userLoginResponse = this.authService.getUserInfos();

    if (!this.userLoginResponse) {
      this.router.navigate(['/']);
    }

    const listaFuncinalidade: Funcionalidade[] = this.userLoginResponse.listaFuncionalidades.filter(
      funcionalidade => {
        return funcionalidade.idFuncionalidade == FuncionalidadeEnum.Configuracoes_Empresa;
      }
    );

    if (listaFuncinalidade.length == 0) {
      this.router.navigate(['/configuracoes']);
    }
  }

  private carregarLookups(): void {
    this.motorFiscalLookupService.getRegimesTributarios().subscribe(lista => {
      this.listaRegimeTributario = lista;
      // `usaRegimeApuracao` depende desta lista: sem ela, o regime gravado ainda nao foi reconhecido.
      this.sincronizarRegimeApuracaoIrpj(false);
    });

    this.motorFiscalLookupService
      .getRegimesApuracaoIrpj()
      .subscribe(lista => (this.listaRegimeApuracaoIrpj = lista));

    this.motorFiscalLookupService
      .getSituacoesContribuinteEmpresa()
      .subscribe(lista => (this.listaSituacaoContribuinteEmpresa = lista));

    this.unidadeFederativaService
      .getUnidadesFederativas()
      .subscribe(lista => (this.listaUnidadeFederativa = lista));
  }

  async popularDadosEmpresa(): Promise<void> {
    try {
      const empresaResponse = await firstValueFrom(
        this.empresaService.obterPorId(this.userLoginResponse.idEmpresa)
      );

      if (empresaResponse.isError) {
        this.alertService.show('Erro', empresaResponse.errorDescription, AlertType.error);
        return;
      }

      this._empresaResponse = empresaResponse;
      this.aplicarDadosNaTela(empresaResponse.empresa);
    } catch (error) {
      this.alertService.show('Erro inesperado', error as any, AlertType.error);
    }
  }

  /** Unico lugar que monta a tela: serve a carga inicial e o Cancelar. */
  private aplicarDadosNaTela(empresa: EmpresaStruct): void {
    this.model.get('nomeEmpresa')?.setValue(empresa.nomeEmpresa);
    this.model.get('cnpj')?.setValue(empresa.cnpj);
    this.model.get('listaTimezone')?.setValue(empresa.timezone?.nome ?? '');

    // Endereco veio plano dentro de `empresa` apos a refatoracao que extinguiu `empresa_endereco`.
    this.model.get('cep')?.setValue(empresa.cep ?? '');
    this.model.get('logradouro')?.setValue(empresa.logradouro ?? '');
    this.model.get('numero')?.setValue(empresa.numero ?? '');
    this.model.get('complemento')?.setValue(empresa.complemento ?? '');
    this.model.get('bairro')?.setValue(empresa.bairro ?? '');
    this.model
      .get('unidadeFederativa')
      ?.setValue([empresa.estado, empresa.uf].filter(Boolean).join(' - '));
    this.model.get('municipio')?.setValue(empresa.municipio ?? '');

    this.model.get('nomeFantasia')?.setValue(empresa.nomeFantasia ?? null);
    this.model.get('dataFundacao')?.setValue(this.converterDataApiParaDate(empresa.dataFundacao));

    // `emitEvent: false` no regime: o valueChanges limparia a apuracao que vamos gravar na linha
    // seguinte. A obrigatoriedade e reavaliada por `sincronizarRegimeApuracaoIrpj()` no final.
    this.model.get('idRegimeTributario')?.setValue(empresa.idRegimeTributario ?? null, {
      emitEvent: false,
    });
    this.model.get('idRegimeApuracaoIrpj')?.setValue(empresa.idRegimeApuracaoIrpj ?? null);
    this.sincronizarRegimeApuracaoIrpj(false);

    this.model.get('inscricaoEstadual')?.setValue(empresa.inscricaoEstadual ?? null);
    // `emitEvent: false`: a carga não é escolha do usuário, então não limpa nem exige a inscrição.
    this.idSituacaoContribuinteEmpresa.setValue(
      empresa.idSituacaoContribuinteEmpresa ?? SituacaoContribuinteEmpresaEnum.ContribuinteIcms,
      { emitEvent: false }
    );
    this.model.get('inscricaoMunicipal')?.setValue(empresa.inscricaoMunicipal ?? null);
    this.model.get('inscricaoSuframa')?.setValue(empresa.inscricaoSuframa ?? null);
    this.aplicarEstadoInscricaoEstadual(false);

    this.cnaePrincipal.setValue(empresa.cnaePrincipal ?? null, { emitEvent: false });

    this.listaSubstitutoTributario.clear({ emitEvent: false });
    (empresa.listaInscricaoSubstitutoTributario ?? []).forEach(item =>
      this.listaSubstitutoTributario.push(this.criarLinhaSubstitutoTributario(item), {
        emitEvent: false,
      })
    );

    // Hoje exibimos a logo Principal. Quando novos tipos forem suportados,
    // basta filtrar pelo enum `TipoLogoEmpresa` desejado nesta linha.
    const logos = empresa.logos ?? [];
    const logoPrincipal = logos.find(l => l.tipo === TipoLogoEmpresa.Principal) ?? logos[0] ?? null;
    this.logoUrlOriginal = logoPrincipal?.urlLogo ?? null;
    this.logoUrlPreview = this.logoUrlOriginal;
    this.logoEdicao = null;
    this.logoFileSelecionado = null;
    this.descartarBlobUrlLogo();

    this.model.markAsPristine();
    this.model.markAsUntouched();
  }

  // ── Regime de apuração do IRPJ ────────────────────────────────────────────

  /**
   * O required entra SOMENTE quando o usuário escolhe o regime nesta sessão. Exigir na carga
   * travaria o Salvar de toda empresa cujo regime usa apuração e nunca a preencheu —
   * ou seja, todas, porque a coluna é nova — impedindo até editar campos sem relação.
   *
   * @param regimeEscolhidoAgora true quando vem do valueChanges do regime, não da carga da tela.
   */
  private sincronizarRegimeApuracaoIrpj(regimeEscolhidoAgora: boolean): void {
    const controle = this.idRegimeApuracaoIrpj;
    const exigir = this.usaRegimeApuracao && regimeEscolhidoAgora;

    controle.setValidators(exigir ? [Validators.required] : []);
    controle.updateValueAndValidity({ emitEvent: false });

    // O mat-error só renderiza com o controle `touched`, e é ele que explica o Salvar desabilitado.
    if (exigir) controle.markAsTouched();
    else controle.markAsUntouched();
  }

  // ── CNAE ──────────────────────────────────────────────────────────────────

  public pesquisarCnae(): void {
    if (this.cnaePrincipal.disabled) return;
    const dialogRef = this.dialog.open(PesquisaCodigoTributacaoModalComponent, {
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '85vh',
      panelClass: 'pesquisa-codigo-tributacao-dialog',
      data: {
        titulo: 'Pesquisar CNAE',
        buscarFn: (pesquisa: string) => this.motorFiscalLookupService.getCnaes(pesquisa).pipe(
          map(lista => ({
            isError: false,
            itens: lista.map(item => ({ codigo: item.codigo ?? '', descricao: item.descricao })),
          })),
        ),
        permitirManual: false,
        registrosIniciais: 20,
        valorInicial: this.cnaePrincipal.value ?? undefined,
      } satisfies PesquisaCodigoTributacaoModalData,
    });
    dialogRef.afterClosed().subscribe((result: PesquisaCodigoTributacaoModalResult | null) => {
      if (!result?.selecionado) return;
      this.cnaePrincipal.setValue(result.selecionado.codigo.replace(/\D/g, ''));
      this.cnaePrincipal.markAsDirty();
    });
  }

  /**
   * Um codigo de subclasse e gravado canonico, so com os 7 digitos — venha do catalogo ou
   * digitado com mascara. Qualquer outro valor aberto e gravado exatamente como foi digitado.
   */
  private normalizarCnae(valor: string | null | undefined): string | null {
    const texto = (valor ?? '').toString().trim();
    if (!texto) return null;

    const digitos = texto.replace(/\D/g, '');
    const pareceCodigo = digitos.length === 7 && /^[\d\s.\-/]+$/.test(texto);

    return pareceCodigo ? digitos : texto;
  }

  // ── Situação perante o ICMS / Inscrição Estadual ──────────────────────────

  private onSituacaoContribuinteEmpresaChange(): void {
    if (!this.isContribuinteIcms) this.model.get('inscricaoEstadual')?.setValue(null);
    this.aplicarEstadoInscricaoEstadual(true);
  }

  /**
   * Habilitada só para contribuinte de ICMS. O required entra apenas quando o usuário escolhe
   * essa situação nesta sessão, como na apuração do IRPJ: exigir na carga travaria o Salvar das
   * empresas que já eram contribuintes e nunca informaram a inscrição.
   *
   * @param escolhidoAgora true quando vem da troca da situação, não da carga da tela.
   */
  private aplicarEstadoInscricaoEstadual(escolhidoAgora: boolean): void {
    const inscricaoEstadual = this.model.get('inscricaoEstadual');
    if (!inscricaoEstadual) return;

    if (this.isContribuinteIcms) inscricaoEstadual.enable({ emitEvent: false });
    else inscricaoEstadual.disable({ emitEvent: false });

    const exigir = this.isContribuinteIcms && escolhidoAgora;
    inscricaoEstadual.setValidators(exigir ? [Validators.required] : []);
    inscricaoEstadual.updateValueAndValidity({ emitEvent: false });
    if (exigir) inscricaoEstadual.markAsTouched();
  }

  // ── Substitutos tributários ───────────────────────────────────────────────

  private criarLinhaSubstitutoTributario(
    item?: EmpresaInscricaoSubstitutoTributarioStruct
  ): FormGroup {
    return this.formBuilder.group({
      idEmpresaInscricaoSubstitutoTributario: new FormControl<number | null>(
        item?.idEmpresaInscricaoSubstitutoTributario ?? null
      ),
      idUnidadeFederativa: new FormControl<number | null>(item?.idUnidadeFederativa ?? null),
      inscricaoEstadual: new FormControl<string | null>(item?.inscricaoEstadual ?? null),
    });
  }

  public adicionarSubstitutoTributario(): void {
    this.listaSubstitutoTributario.push(this.criarLinhaSubstitutoTributario());
    this.model.markAsDirty();
  }

  public removerSubstitutoTributario(indice: number): void {
    this.listaSubstitutoTributario.removeAt(indice);
    this.model.markAsDirty();
  }

  /**
   * Duas regras, avaliadas juntas porque ambas marcam a propria linha:
   *  - nao pode haver duas linhas com a mesma UF;
   *  - linha com UF exige Inscricao Estadual, e vice-versa.
   * Linha totalmente vazia nao e erro: ela e descartada no envio.
   */
  private validarSubstitutosTributarios(): void {
    const linhas = this.listaSubstitutoTributario.controls as FormGroup[];

    const ocorrenciasPorUf = new Map<number, number>();
    linhas.forEach(linha => {
      const uf = linha.get('idUnidadeFederativa')?.value;
      if (uf) ocorrenciasPorUf.set(uf, (ocorrenciasPorUf.get(uf) ?? 0) + 1);
    });

    linhas.forEach(linha => {
      const controleUf = linha.get('idUnidadeFederativa');
      const controleInscricao = linha.get('inscricaoEstadual');
      const uf: number | null = controleUf?.value ?? null;
      const inscricao: string = (controleInscricao?.value ?? '').toString().trim();

      // Nenhum destes controles tem outro validador, entao zerar e seguro.
      const errosUf: Record<string, boolean> = {};
      const errosInscricao: Record<string, boolean> = {};

      if (uf && (ocorrenciasPorUf.get(uf) ?? 0) > 1) errosUf['ufDuplicada'] = true;
      if (!uf && inscricao) errosUf['required'] = true;
      if (uf && !inscricao) errosInscricao['required'] = true;

      controleUf?.setErrors(Object.keys(errosUf).length ? errosUf : null, { emitEvent: false });
      controleInscricao?.setErrors(
        Object.keys(errosInscricao).length ? errosInscricao : null,
        { emitEvent: false }
      );
    });
  }

  // ── Logo ──────────────────────────────────────────────────────────────────

  /**
   * Abre o dialog para visualizar/trocar/remover a logo. A persistencia ocorre apenas
   * quando o usuario clica em Salvar no footer.
   */
  abrirDialogLogo(): void {
    const dialogRef = this.dialog.open<
      EmpresaLogoDialogComponent,
      EmpresaLogoDialogData,
      EmpresaLogoDialogResult
    >(EmpresaLogoDialogComponent, {
      data: { urlLogoAtual: this.logoUrlPreview ?? this.logoUrlOriginal },
      width: '640px',
      maxWidth: '95vw',
      maxHeight: '95vh',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      this.descartarBlobUrlLogo();

      if (result.remover) {
        this.logoUrlPreview = null;
        this.logoFileSelecionado = null;
        this.logoEdicao = {
          remover: true,
          arquivoBase64: null,
          extensao: null,
          nomeOriginal: null,
          contentType: null,
          tipo: TipoLogoEmpresa.Principal,
        };
        return;
      }

      if (result.arquivo) {
        this.logoBlobUrlAtivo = result.previewUrl;
        this.logoUrlPreview = result.previewUrl;
        this.logoFileSelecionado = result.arquivo;

        const ext = (result.arquivo.name.split('.').pop() || '').toLowerCase();
        this.logoEdicao = {
          remover: false,
          arquivoBase64: null,
          extensao: ext,
          nomeOriginal: result.arquivo.name,
          contentType: result.arquivo.type || null,
          tipo: TipoLogoEmpresa.Principal,
        };
      }
    });
  }

  // ── Rodapé ────────────────────────────────────────────────────────────────

  /** Sem alteracao pendente, volta para Configuracoes; havendo, descarta e restaura. */
  public cancelar(): void {
    const temAlteracaoPendente = this.model.dirty || this.logoEdicao !== null;

    if (!temAlteracaoPendente) {
      this.router.navigate(['/configuracoes']);
      return;
    }

    this.descartarBlobUrlLogo();
    this.logoFileSelecionado = null;
    this.aplicarDadosNaTela(this._empresaResponse.empresa);
  }

  public async salvar(): Promise<void> {
    if (this.isSalvarDesabilitado) return;

    this.isLoadingSalvar = true;
    try {
      // A logo tem endpoint proprio desde antes desta US e continua separada.
      if (this.logoEdicao) await this.persistirLogo();

      const response = await firstValueFrom(
        this.empresaService.alterarDadosFiscais(
          this.userLoginResponse.idEmpresa,
          this.montarRequest()
        )
      );

      if (response.isError) {
        // Erro de validacao da API: mantem as alteracoes em tela para o usuario corrigir.
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        return;
      }

      await this.popularDadosEmpresa();
      this.alertService.show('Sucesso', 'Informações da empresa atualizadas.', AlertType.success);
    } catch (error: any) {
      this.alertService.show(
        'Erro',
        error?.message ?? 'Falha ao salvar as informações da empresa.',
        AlertType.error
      );
    } finally {
      this.isLoadingSalvar = false;
    }
  }

  private montarRequest(): EmpresaDadosFiscaisRequest {
    const valor = this.model.getRawValue();

    const request = new EmpresaDadosFiscaisRequest();
    request.nomeFantasia = this.normalizarTexto(valor.nomeFantasia);
    request.dataFundacao = this.converterDateParaDataApi(valor.dataFundacao);
    request.cnaePrincipal = this.normalizarCnae(valor.cnaePrincipal);
    request.idRegimeTributario = valor.idRegimeTributario ?? null;
    // Zera só com o regime reconhecido e diferente de Normal. Não classificado (`null`) reenvia o
    // que está na tela: apagar por não saber perderia dado que ninguém pediu para mexer.
    request.idRegimeApuracaoIrpj =
      this.classificacaoRegime === false ? null : (valor.idRegimeApuracaoIrpj ?? null);
    request.idSituacaoContribuinteEmpresa = valor.idSituacaoContribuinteEmpresa;
    request.inscricaoEstadual = this.isContribuinteIcms
      ? this.normalizarTexto(valor.inscricaoEstadual)
      : null;
    request.inscricaoMunicipal = this.normalizarTexto(valor.inscricaoMunicipal);
    request.inscricaoSuframa = this.normalizarTexto(valor.inscricaoSuframa);

    // Linhas totalmente vazias sao descartadas, conforme a US.
    request.listaInscricaoSubstitutoTributario = (valor.listaSubstitutoTributario ?? [])
      .filter(
        (linha: any) =>
          linha.idUnidadeFederativa || (linha.inscricaoEstadual ?? '').toString().trim()
      )
      .map((linha: any) => {
        const item = new EmpresaInscricaoSubstitutoTributarioStruct();
        item.idEmpresaInscricaoSubstitutoTributario =
          linha.idEmpresaInscricaoSubstitutoTributario ?? null;
        item.idUnidadeFederativa = linha.idUnidadeFederativa;
        item.inscricaoEstadual = (linha.inscricaoEstadual ?? '').toString().trim();
        return item;
      });

    return request;
  }

  private persistirLogo(): Promise<void> {
    if (!this.logoEdicao) return Promise.resolve();

    if (this.logoEdicao.remover) {
      return this.executarSalvarLogo({ logo: this.logoEdicao });
    }

    if (this.logoFileSelecionado) {
      return this.converterFileParaBase64(this.logoFileSelecionado).then(base64 =>
        this.executarSalvarLogo({ logo: { ...this.logoEdicao!, arquivoBase64: base64 } })
      );
    }

    return Promise.resolve();
  }

  private executarSalvarLogo(request: EmpresaLogoRequest): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.empresaService.salvarLogo(request).subscribe({
        next: (response: ReturnStruct) => {
          if (response.isError) {
            reject(new Error(response.errorDescription));
            return;
          }
          resolve();
        },
        error: err => reject(err),
      });
    });
  }

  // ── Utilitários ───────────────────────────────────────────────────────────

  public onDataFundacaoInput(event: Event): void {
    MaskService.onDateInput(event, this.model.get('dataFundacao'));
  }

  public onDataFundacaoKeydown(event: KeyboardEvent): void {
    const teclasPermitidas = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'];
    const isAtalho = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
    if (teclasPermitidas.includes(event.key) || isAtalho) return;
    if (!/^\d$/.test(event.key)) event.preventDefault();
  }

  private normalizarTexto(valor: string | null | undefined): string | null {
    const texto = (valor ?? '').toString().trim();
    return texto.length ? texto : null;
  }

  /**
   * A coluna e `date`. Montar/ler a data por componentes evita o deslocamento de um dia que
   * o parse ISO causaria em UTC-03 (`new Date('2009-03-12')` cai em 11/03 as 21h locais).
   */
  private converterDateParaDataApi(data: Date | null): string | null {
    if (!data) return null;
    const valor = new Date(data);
    if (isNaN(valor.getTime())) return null;
    const ano = valor.getFullYear();
    const mes = `${valor.getMonth() + 1}`.padStart(2, '0');
    const dia = `${valor.getDate()}`.padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  private converterDataApiParaDate(valor: Date | string | null): Date | null {
    if (!valor) return null;
    const texto = valor.toString().substring(0, 10);
    const [ano, mes, dia] = texto.split('-').map(Number);
    if (!ano || !mes || !dia) return null;
    return new Date(ano, mes - 1, dia);
  }

  private converterFileParaBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const idx = result.indexOf(',');
        resolve(idx >= 0 ? result.substring(idx + 1) : result);
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }

  private descartarBlobUrlLogo(): void {
    if (this.logoBlobUrlAtivo) {
      URL.revokeObjectURL(this.logoBlobUrlAtivo);
      this.logoBlobUrlAtivo = null;
    }
  }
}
